import { cn } from '@/lib/utils';
import { useLanguage } from '@/contexts/LanguageContext';

interface DrinkGuidanceTooltipProps {
  step: 'initial' | 'trial_complete' | 'first_drink_logged' | 'complete';
  className?: string;
}

export function DrinkGuidanceTooltip({ step, className }: DrinkGuidanceTooltipProps) {
  const { t } = useLanguage();

  const getContent = () => {
    switch (step) {
      case 'initial':
        return (
          <div className="space-y-1">
            <p className="text-sm font-semibold">{t('drinkGuidanceInitialTitle')}</p>
            <p className="text-sm">{t('drinkGuidanceInitialText')}</p>
          </div>
        );
      case 'trial_complete':
        return (
          <div className="space-y-1">
            <p className="text-sm font-semibold">{t('drinkGuidanceTrialTitle')}</p>
            <p className="text-sm">{t('drinkGuidanceTrialText')}</p>
          </div>
        );
      default:
        return null;
    }
  };

  const content = getContent();
  if (!content) return null;

  return (
    <div className={cn("relative", className)}>
      {/* Arrow pointing up */}
      <div 
        className="absolute left-1/2 -translate-x-1/2 -top-2 w-0 h-0"
        style={{
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderBottom: '10px solid hsl(var(--primary))',
        }}
      />
      {/* Tooltip body */}
      <div className="bg-primary text-primary-foreground px-4 py-3 rounded-lg text-center shadow-lg">
        {content}
      </div>
    </div>
  );
}
